<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="企业名称">
              <a-input  v-model="queryParam.enterpriseName"  />
            </a-form-item>
          </a-col>
          <a-col :span="18" :style="{ textAlign: 'right' }">
            <a-button type="primary" style="margin-left: 8px" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px" @click="restdata()">清空</a-button>
          </a-col>
        </a-row>
        <a-row>

        </a-row>
        <a-divider/>

      </a-form>

    </div>
    <s-table
      size="default"
      ref="table"
      :columns="columns"
      :data="loadData"
      style="margin-top: 24px"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="payment(record)">确认支付</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  // import { getDictMap } from '../../utils/dict'
  import { OfflinePayment ,Payupdate} from '@/api/enterprise/enterpriseAccount'


  export default {
    name: "enterpriseAccount",
    components:{
      STable,
    },
    data(){
      return{
        visible:false,
        confirmLoading:false,
        queryParam:{},
        form:this.$form.createForm(this),
        resTypes:[],
        loadData: parameter => {
          return OfflinePayment(Object.assign(parameter, this.queryParam))
        },
        columns: [
          {
            title: '序号',
            dataIndex: 'row',
            align: 'center'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },

          },
          {
            title: '企业名称',
            dataIndex: 'enterpriseName',
            align: 'center'
          },
          {
            title: '交易号',
            dataIndex: 'rechargeId',
            align: 'center'
          },
          {
            title: '交易金额',
            dataIndex: 'totalAmount',
            align: 'center'
          },
        ],
      }
    },
    methods:{
      //重置
      restdata(){
        this.queryParam={}
      },
      //确认支付
      payment(values){
        Payupdate({
          enterpriseId:values.enterpriseId,
          rechargeId:values.rechargeId
        }).then(res=>{
          if(res.code==0){
           this.$message.success('确认支付成功')
            this.$refs.table.refresh()
          }
        })
      },
    },
    async created(){

    }
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>